import React, { useState } from "react";
import API from "../../services/api.ts";
import { toast } from "react-toastify";

const MedicalImageForm = ({ refreshMedicalImages }) => {
  const [patientId, setPatientId] = useState("");
  const [description, setDescription] = useState("");
  const [modality, setModality] = useState("");
  const [imageFile, setImageFile] = useState(null);

  // A simple list of modalities; you could also fetch from the server if needed
  const modalities = ["X-ray", "CT", "MRI", "Ultrasound"];

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      // Use FormData for file (image) upload
      const formData = new FormData();
      formData.append("patient_id", patientId);
      formData.append("description", description);
      formData.append("modality", modality);
      // add the user info from local storage or context if needed
      formData.append("uploaded_by", localStorage.getItem("username"));
      if (imageFile) {
        formData.append("image", imageFile);
      }

      await API.post("/data_manager/medical-images/upload-dcm/", formData, {
        headers: { "Content-Type": "multipart/form-data" },
      });

      toast.success("Medical image added successfully.");
      // Reset form fields
      setPatientId("");
      setDescription("");
      setModality("");
      setImageFile(null);
      // Refresh the list
      refreshMedicalImages();
    } catch (err) {
      console.error("Failed to add medical image:", err);
      toast.error("Failed to add medical image.");
    }
  };

  return (
    <form className="row g-3" onSubmit={handleSubmit}>
      <div className="col-md-3">
        <input
          type="text"
          className="form-control"
          placeholder="Patient ID"
          value={patientId}
          onChange={(e) => setPatientId(e.target.value)}
          required
        />
      </div>
      <div className="col-md-3">
        <select
          className="form-select"
          value={modality}
          onChange={(e) => setModality(e.target.value)}
          required
        >
          <option value="" disabled>Select Modality</option>
          {modalities.map((mod) => (
            <option key={mod} value={mod}>
              {mod}
            </option>
          ))}
        </select>
      </div>
      <div className="col-md-3">
        <input
          type="file"
          className="form-control"
          accept=".dcm"
          onChange={(e) => setImageFile(e.target.files[0])}
          required
        />
      </div>
      <div className="col-md-12">
        <textarea
          className="form-control"
          rows={3}
          placeholder="Description (optional)"
          value={description}
          onChange={(e) => setDescription(e.target.value)}
        />
      </div>
      <div className="col-md-12">
        <button type="submit" className="btn btn-success">
          Add Medical Image
        </button>
      </div>
    </form>
  );
};

export default MedicalImageForm;
